module.exports = __webpack_public_path__ + "media/images/fallback_spreadsheet-1e6c5a30b8f11ee5b89bcd3c06d7e68a.png";